/* eslint-disable no-underscore-dangle,no-unused-expressions,jsx-a11y/click-events-have-key-events */
/* global Dropbox:0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { noop } from '../../shared/helpers';

const WARNING =
  'Cannot change the app key once the Dropbox script has been loaded';

export default class DropboxChooser extends Component {
  static defaultProps = {
    appKey: null,
    className: '',
    extensions: null,
    linkType: 'preview',
    multiselect: false,
    folderselect: false,
    openOnClick: true,
    onSuccess: noop,
    onCancel: noop,
  };

  state = {
    isScriptLoaded: false,
  };

  constructor(props) {
    super(props);
    this._createScript = this.createScript.bind(this);
    this.openDropboxChooserPopup = this.openDropboxChooserPopup.bind(this);
  }

  componentWillMount() {
    const { appKey } = this.props;

    if (appKey) {
      this._createScript(appKey);
    }
  }

  componentWillReceiveProps(newProps) {
    const { appKey } = newProps;
    const { isScriptLoaded } = this.state;

    if (!isScriptLoaded && appKey && !this.props.appKey) {
      this._createScript(appKey);
    }

    if (isScriptLoaded && appKey && !this.props.appKey) {
      console.warn ? console.warn(WARNING) : console.log(WARNING); // eslint-disable-line no-console
    }
  }

  createScript(appKey) {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://www.dropbox.com/static/api/2/dropins.js';
    script.id = 'dropboxjs';
    script.setAttribute('data-app-key', appKey);
    script.onload = () => {
      this.setState({ isScriptLoaded: true }, () => {
        !this.props.children && this.attach();
      });
    };

    document.body.appendChild(script);
  }

  getOptions = () => {
    const {
      extensions,
      linkType,
      multiselect,
      folderselect,
      onCancel,
      onSuccess,
    } = this.props;

    const options = {
      success: onSuccess,
      cancel: onCancel,
      linkType,
      multiselect,
      folderselect,
    };

    if (extensions) {
      options.extensions = extensions;
    }

    return options;
  };

  attach = () => {
    const button = Dropbox.createChooseButton(this.getOptions());
    this.chooser.appendChild(button);
  };

  openDropboxChooserPopup() {
    if (this.props.openOnClick) Dropbox.choose(this.getOptions());
  }

  render() {
    const { className } = this.props;

    return (
      <div
        className={`card-dash-dropbox ${className}`}
        onClick={() => {
          this.props.children && this.openDropboxChooserPopup();
        }}
        ref={ref => {
          this.chooser = ref;
        }}
      >
        <div className="row flex-fill">{this.props.children}</div>
      </div>
    );
  }
}

DropboxChooser.propTypes = {
  appKey: PropTypes.string,
  className: PropTypes.string,
  extensions: PropTypes.arrayOf(PropTypes.string),
  linkType: PropTypes.oneOf(['preview', 'direct']),
  multiselect: PropTypes.bool,
  folderselect: PropTypes.bool,
  openOnClick: PropTypes.bool,
  onCancel: PropTypes.func,
  onSuccess: PropTypes.func,
  children: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/components/DropboxChooser/DropboxChooser.js